module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-4-5 login-container l-box"
  }, [_c('h1', [_vm._v(_vm._s(_vm.appTitle))]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Make daily notes.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "pure-button login-button",
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Login to start")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bd55cd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginPage.vue
// module id = 121
// module chunks = 1